<template>
    <div class="float-left">
        <b-button-group class="float-right">
            <b-button
                variant="success"
                @click="abrirModal()"
                v-if="
                    $temAcessoView('CONV-00') &&
                    parentData.idSituacaoConvenio != 9 &&
                    modoCadastro
                "
                >Adicionar
            </b-button>
        </b-button-group>

        <i
            class="fa fa-pencil-square fa-lg icon-button"
            title="Alterar Documento"
            v-if="
                $temAcessoView('CONV-00') &&
                parentData.idSituacaoConvenio != 9 &&
                !modoCadastro
            "
            @click.stop="abrirModal()"
        ></i>

        <b-modal
            id="modalAdicionarCronograma"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                Documento Prestação Contas -
                <b-badge variant="warning">{{ modo }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>

            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label for="idDocumento">Documento</label>
                        <b-input-group>
                            <b-form-select
                                type="text"
                                :options="combo"
                                value-field="idDocumento"
                                text-field="descricao"
                                v-model="obj.idDocumento"
                                :disabled="!modoCadastro"
                            >
                            </b-form-select>
                            <b-form-invalid-feedback
                                >Documento é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="12">
                    <b-form-group>
                        <label for="vcObservacoes">Observações</label>
                        <b-input-group>
                            <b-form-textarea
                                type="text"
                                rows="3"
                                v-model="obj.vcObservacoes"
                            >
                            </b-form-textarea>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="this.$v.$invalid"
                    @click.stop="salvar()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        parentData: Object,
        documento: Object,
        modoCadastro: Boolean
    },

    validations: {
        idDocumento: { required }
    },

    watch: {
        'obj.idDocumento'() {
            this.idDocumento = null
            if (this.obj.idDocumento > 0) {
                this.idDocumento = this.obj.idDocumento
            }
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            idDocumento: null,
            combo: [],
            modo: '',
            obj: {
                idDocumento: null,
                idConvenio: null,
                vcObservacoes: null
            }
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true

            this.obj.idDocumento = null
            this.obj.idConvenio = null
            this.obj.vcObservacoes = null
            this.modo = 'NOVO'

            if (!this.modoCadastro) {
                this.obj.idDocumento = this.documento.idDocumento
                this.obj.idConvenio = this.documento.idConvenio
                this.obj.vcObservacoes = this.documento.vcObservacoes

                this.modo = 'EDITAR'
            }

            this.carregaCombo()
        },

        fecharModal() {
            this.mostrarModal = false
        },

        carregaCombo() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.ListarDocumentoPrestacaoContas().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.combo = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        salvar() {
            this.obj.idConvenio = this.$route.params.convenioId

            if (this.modoCadastro) {
                this.$store.dispatch('addRequest')
                ConveniosServicos.InserirDocumentoPrestacaoContasConvenio(
                    this.obj
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$emit('atualizarCadastro')
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else {
                this.$store.dispatch('addRequest')
                ConveniosServicos.AlterarDocumentoPrestacaoContasConvenio(
                    this.obj
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$emit('atualizarCadastro')
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }

            this.fecharModal()
        }
    }
}
</script>

